
import MemberInfoSection from "@/components/member/MemberInfoSection.vue";
import HappeningOverview from "@/components/member/happening/HappeningOverview.vue";
import RewardOverview from "@/components/member/reward/RewardOverview.vue";
import OfferOverview from "@/components/member/offer/OfferOverview.vue";
import MemberHeader from "@/components/member/MemberHeader.vue";
import {computed} from "vue";
import store from "@/store";

export default {
  name: "Member",
  displayName: "Member",
  components: {MemberHeader, OfferOverview, RewardOverview, HappeningOverview, MemberInfoSection},
  setup() {
    const type = computed(() => store.state.selectedType);
    return {
      type,
    };
  }
}
